module.exports = "<div class=\"busy-spinner-loading\">\n  <div class=\"spinner\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/services/busy-spinner/busy-spinner.component.html
// module id = ../../../../../src/app/services/busy-spinner/busy-spinner.component.html
// module chunks = 0